/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowLeft = createReactComponent("arrow-left", "IconArrowLeft", [
  ["path", { d: "M5 12l14 0", key: "svg-0" }],
  ["path", { d: "M5 12l6 6", key: "svg-1" }],
  ["path", { d: "M5 12l6 -6", key: "svg-2" }]
]);

export { IconArrowLeft as default };
//# sourceMappingURL=IconArrowLeft.js.map
